import {
  DotsThreeVertical,
  PencilSimpleLine,
  Trash,
} from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import { Dialog, DialogContent } from "common/components/ui/Dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";

import DeleteLabel from "./DeleteLabel";

import type { LabelType } from "../../types";

export default function LabelDropdownMenu({
  labelId,
  editLabel,
  labelType,
}: {
  labelId: string;
  editLabel: () => void;
  labelType: LabelType;
}) {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            intent="iconOnly"
            size="sm"
            variant="secondary-black"
            data-cy="label-dropdown-button"
          >
            <DotsThreeVertical />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuList>
            <DropdownMenuItem onClick={editLabel}>
              <PencilSimpleLine size={20} />
              Edit label
            </DropdownMenuItem>
            <DropdownMenuItem
              variant="danger"
              onClick={() => setIsDeleteOpen(true)}
              data-cy="label-dropdown-delete"
            >
              <Trash />
              Delete label
            </DropdownMenuItem>
          </DropdownMenuList>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog open={isDeleteOpen} onOpenChange={setIsDeleteOpen}>
        <DialogContent className="md:w-[448px]">
          <DeleteLabel
            labelId={labelId}
            onBack={() => setIsDeleteOpen(false)}
            labelType={labelType}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
